/**
 * @internal
 *
 * Debug Event values are specific to JetStream ingestion
 * DO NOT CHANGE without downstream updates confirmed.
 */
export enum DebugEventReason {
    WEB_PUSH_UNSUPPORTED = 'web_push_unsupported',
    HOST_NOT_WHITELISTED = 'host_not_whitelisted',
    SW_INSTALL_FAILED = 'sw_install_failed',
    PROMPTS_LOAD_FAILED = 'load_failed',
    NO_ELIGIBLE_PROMPTS = 'no_eligible_prompts',
    PROMPTING_SUPPRESSED = 'prompting_suppressed',
    USER_PERMISSION_DENIED = 'user_permission_denied',
    USER_PERMISSION_DISMISSED = 'user_permission_dismissed',
    USER_PERMISSION_GRANTED = 'user_permission_granted',
    PROMPT_INELIGIBLE_FCAP = 'prompt_ineligible_fcap',
    /**
     * A SLIDE prompt's theme carried nothing usable at all — no text-config object for title,
     * subtitle, or either button, no valid colour, no valid image, no recognised layout — so the
     * DOM renderer returned nothing to display. An empty-string field (e.g. a deliberate
     * title-only prompt) does not trigger this; only a theme with no configured fields does. There
     * is no `template_html` fallback, so this is the only outcome for such a payload — surfacing
     * it as a debug event is what makes "prompt matched but nothing rendered" distinguishable from
     * "no traffic at all".
     */
    SLIDE_PROMPT_THEME_UNUSABLE = 'slide_prompt_theme_unusable',

    // event not sent for following reasons
    USER_DELETED = 'user_deleted',
}
